import { PlayerSide } from "../ai/TableAI";

export function GetPlayerSide(playerIndex: number): PlayerSide
{
    // NOTE: prob should use Players.PLAYER_INDEX and.. player's buddy's index?
    switch(playerIndex) {
        case 0:
        case 2: 
            return PlayerSide.US;

        case 1:
        case 3:
            return PlayerSide.THEM;

        default:
            return PlayerSide.NONE;
    }
}